var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navigation'),_c('Carousel'),_c('MainContent'),_c('AboutUs'),_c('AboutUs2'),_c('Services'),_c('Resources'),_c('Team'),_c('Testimonials'),_c('Contact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }